import { useState } from "react";
import { useTurnstile } from "@/lib/turnstile";

const IDS = {
  demo: process.env.REACT_APP_FORMSPREE_DEMO_ID,
  waitlist: process.env.REACT_APP_FORMSPREE_WAITLIST_ID,
};

const isConnected = (kind) => Boolean(IDS[kind]) && !IDS[kind].startsWith("YOUR_");

export const useFormspree = (kind) => {
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const ts = useTurnstile();

  const submit = async (data) => {
    if (!isConnected(kind)) {
      setStatus("unconnected");
      setError("This form isn't connected yet. Please check back soon.");
      return;
    }
    if (ts.enabled && !ts.token) {
      setStatus("error");
      setError(ts.failed
        ? "Our spam check couldn't load on this page. Please refresh and try again."
        : "We're still checking that you're not a robot. Please try again in a moment.");
      return;
    }
    setStatus("sending");
    setError("");
    try {
      const res = await fetch(`https://formspree.io/f/${IDS[kind]}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(ts.enabled ? { ...data, "cf-turnstile-response": ts.token } : data),
      });
      if (res.ok) {
        setStatus("success");
        return;
      }
      const body = await res.json().catch(() => ({}));
      const msg = Array.isArray(body?.errors) ? body.errors.map((e) => e?.message).filter(Boolean).join(" ") : "";
      setError(msg || "Something went wrong sending your details. Please try again.");
      setStatus("error");
      ts.reset();
    } catch {
      setError("We couldn't reach the server. Please check your connection and try again.");
      setStatus("error");
      ts.reset();
    }
  };

  return { status, error, submit, reset: () => setStatus("idle"), turnstileRef: ts.ref };
};
